import React from 'react';
import { createRoot } from 'react-dom/client';

import SsoFailPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const createSsoFailScreen = ({ userId, message, loginLink }) => {
  const root = createRoot(document.getElementById('ssoFailPanel'));
  if (isSupportedBrowser()) {
    root.render(
      <AuthScreenLayout>
        <SsoFailPanel loginLink={loginLink} userId={userId} message={message} />
      </AuthScreenLayout>
    );
  } else {
    root.render(<UnsupportedBrowsers />);
  }
};

window.createSsoFailScreen = createSsoFailScreen;
